import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { PageEvent } from '@angular/material/paginator';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { PaymentMessageComponent } from '../payment-message/payment-message.component';
import { Router } from '@angular/router';
import { FeeProcessComponent } from '../fee-process/fee-process.component';

@Component({
  selector: 'app-pay-gateway',
  templateUrl: './pay-gateway.component.html',
  styleUrls: ['./pay-gateway.component.scss']
})
export class PayGatewayComponent implements OnInit {
  paymentGatewayList: any;
  dialogRef: MatDialogRef<any>;
  constructor(
    private dialog: MatDialog,public router: Router, public dialogRef2: MatDialogRef<FeeProcessComponent>,
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef1: MatDialogRef<PayGatewayComponent>,
    private modalPopupService: ModalpopService,
  ) { }

  ngOnInit(): void {
    this.getPaymentGatewayData();

  }

  getPaymentGatewayData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getPaymentGateway(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.paymentGatewayList = res.data.filter(items => items.isActive === 'Y');
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
   }

   redirect(item){
    let data = {}
    data['message'] = 'Do You Want to Redirect to ' + item.gatewayName +  ' Payment Gateway?'
    data['title'] = 'Redirect to Payment Gateway'
    data['icon'] = 'fas fa-credit-card'
    data['gateway'] = item 
    data['paydata'] = this.data
    this.dialogRef = this.modalPopupService.openPopup<PaymentMessageComponent>(PaymentMessageComponent, data);
   }

   redirectToFeedback(to: string): void {
    this.router.navigate([to]);
  }

  close(): void {
    // this.dialogRef1.close(); 
    this.dialog.closeAll();
  }

}
